export enum StatusEnum {
  ATIVO = 'true',
  INATIVO = 'false',
}
